import PastOrdersSFC from "./PastOrders.vue";

export const PastOrders = PastOrdersSFC;
